var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    fill: "url(#checked)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "checked",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checked_3546_64460",
    transform: "scale(0.0555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "checked_3546_64460",
    width: 18,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKtJREFUeNpiVEpZMZ+BgSGBgTKwgIkKhoBAAhMDlQDZBvFxsVJuEMiQZSVODF2JZnAxFnIN0ZQVgPM/fftNmouQDbn++ANDVM8+sCFYvYbud2IMwTAI5GeQYnTDCBmCYhBIsZasIFgxsmHEGIJiEEgSpAikGGaYjDA3UYaAACMwi/zHFysgQMgQrIGN7DJiDcGZIGGGrT12nyhDsHqN7nmNpgYtoII5CwACDADNSm6Olxuj/gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ed1a1c87f67c2f06d8600f70fa6b5c0f.svg";
export { ForwardRef as ReactComponent };